import { ApiPermission, ApiTokenListItemDTO, UserType } from "@bvhi/backend-api";
import { GridColDef, Stack } from "@bvhi/ui-base";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ActionCells } from "../../../../../components/datagrid/cells/action-cells";
import { DateCell } from "../../../../../components/datagrid/cells/date-cell";
import { PosDetailLinkCell } from "../../../pointofsale/list/components/datagrid/pos-detail-link-cell.tsx";
import { ActiveScopeGroupChip } from "../components/datagrid/active-scope-group-chip.tsx";

export const useApiTokenDataGridDefinitions = (handleDelete: (organisationId: string) => void, userType: UserType) => {
  const { t } = useTranslation(["api-token"]);

  const columns: GridColDef<ApiTokenListItemDTO>[] = useMemo(() => {
    return [
      {
        display: "flex",
        field: "name",
        headerName: t("api-token:api.token.entity.field.name"),
        minWidth: 150,
        width: 200,
        maxWidth: 250,
        sortable: false,
      },
      {
        display: "flex",
        field: "createdAt",
        headerName: t("api-token:api.token.entity.field.created.at"),
        minWidth: 150,
        width: 200,
        maxWidth: 250,
        sortable: false,
        renderCell: (params) => <DateCell date={params.row.createdAt} />,
      },
      ...(userType === UserType.AUDIOLOGIST
        ? ([
            {
              display: "flex",
              field: "connectedPointOfSaleId",
              headerName: t("api-token:api.token.entity.field.connected.pos"),
              minWidth: 150,
              width: 300,
              maxWidth: 400,
              sortable: false,
              renderCell: (params) => {
                if (!params.row.connectedPointOfSaleId || !params.row.connectedPointOfSaleName) {
                  return t("api-token:api.token.entity.field.connected.noPos");
                }
                return <PosDetailLinkCell label={params.row.connectedPointOfSaleName} posId={params.row.connectedPointOfSaleId} />;
              },
            },
            {
              field: "activeScopeGroups",
              headerName: t("api-token:api.token.entity.field.active.scope.groups"),
              minWidth: 300,
              width: 800,
              maxWidth: 800,
              sortable: false,
              renderCell: (params) => (
                <Stack direction="row" py={1} spacing={1} useFlexGap>
                  {params.row.activeScopeGroups.map((value) => (
                    <ActiveScopeGroupChip key={value} type={value} />
                  ))}
                </Stack>
              ),
            },
          ] as GridColDef<ApiTokenListItemDTO>[])
        : []),
      {
        field: "id",
        headerName: t("api-token:api.token.datagrid.actions"),
        flex: 1,
        minWidth: 125,
        headerClassName: "datagrid-sticky-right",
        cellClassName: "datagrid-sticky-right",
        align: "right",
        headerAlign: "right",
        sortable: false,
        resizable: false,
        renderCell: (params) => (
          <ActionCells
            deletePermission={ApiPermission["api-token:delete"]}
            detailPermission={undefined}
            handleDelete={handleDelete}
            id={params.row.id}
            showDeleteAction={true}
            showDetailAction={false}
          />
        ),
      },
    ];
  }, [t, handleDelete, userType]);

  return { columns };
};
